export const CyPushNeededInfo = {
  Alert: "AlertOfflineChanges",
} as const;
